import React from 'react';
import { Box, Grid, Paper, Typography } from '@mui/material';
import { NavLink, Outlet, Route, Routes } from 'react-router-dom';
import './Portfolio.css';

import ProjectMenu from './ProjectMenu/ProjectMenu';
import Ecommerce from './Ecommerce/Ecommerce';
import Business from './Business/Business';
import Niche from './Niche/Niche';
import Blog from './Blog/Blog';
import Portfolios from './Portfolios/Portfolios';

const Portfolio = () => {

    return (
        <Box sx={{ p: 5, borderRadius: '10px' }} component={Paper} elevation={5}>
            <Box>
                <Typography variant='h6' sx={{ fontWeight: '700', fontSize: {xs: '18px',sm:'21px'}, color: 'primary.main' }}>Resume</Typography>
                <Typography variant='h4' sx={{ fontWeight: '700', fontSize: {xs: '25px',sm:'47px'} }}>My Works <br /> which i did for clients.</Typography>
            </Box>




            <Routes>
                <Route path='/' element={<ProjectMenu />}>

                    <Route path='/' element={<Ecommerce />}></Route>
                    <Route path='project/business' element={<Business />}></Route>
                    <Route path='project/niche' element={<Niche />}></Route>
                    <Route path='project/blog' element={<Blog />}></Route>
                    <Route path='project/portfolios' element={<Portfolios />}></Route>
                </Route>
            </Routes>

        </Box>
    );
};

export default Portfolio;